import React from "react";
import { IntlProvider } from "react-intl";
import versionSelect from "@atlassiansox/jsw-interactive-board";
import { StyleReset } from "../../base/StyleReset";
import { AnalyticsListener } from "@atlaskit/analytics-next";
import { sendAnalytics } from "../../utils/send-analytics";

const JswInteractiveBoardContainer = ({toDo,
					inProgress,
					done,
					create,
					restartDemo,
					avatarGroupAriaLabel,
					createIssueModalHeader,
					createIssueModalInput1Label,
					createIssueModalInput2Label,
					createIssueModalInput3Label,
					createIssueModalInput3Placeholder,
					createIssueModalInput4Label,
					createIssueModalInput4Placeholder,
					createIssueModalInput5Label,
					createIssueModalInput6Label,
					createIssueModalInput7Label,
					createIssueModalInput8Label,
					createIssueModalProjectOption1,
					createIssueModalProjectAssetLabel1,
					createIssueModalIssueTypeOption1,
					createIssueModalIssueTypeAssetLabel1,
					createIssueModalIssueTypeOption2,
					createIssueModalIssueTypeAssetLabel2,
					createIssueModalIssueTypeOption3,
					createIssueModalIssueTypeAssetLabel3,
					createIssueModalAssigneeOption1,
					createIssueModalAssigneeAssetLabel1,
					createIssueModalAssigneeOption2,
					createIssueModalAssigneeAssetLabel2,
					createIssueModalAssigneeOption3,
					createIssueModalAssigneeAssetLabel3,
					createIssueModalPriorityOption1,
					createIssueModalPriorityAssetLabel1,
					createIssueModalPriorityOption2,
					createIssueModalPriorityAssetLabel2,
					createIssueModalPriorityOption3,
					createIssueModalPriorityAssetLabel3,
					createIssueModalPriorityOption4,
					createIssueModalPriorityAssetLabel4,
					createIssueModalEpicLinkOption1,
					createIssueModalEpicLinkOption1Description,
					createIssueModalEpicLinkAssetLabel1,
					createIssueModalEpicLinkOption2,
					createIssueModalEpicLinkOption2Description,
					createIssueModalEpicLinkAssetLabel2,
					createIssueModalEpicLinkOption3,
					createIssueModalEpicLinkOption3Description,
					createIssueModalEpicLinkAssetLabel3,
					createIssueModalSubmitBtn,
					spotlightInitialCreateButtonHeading,
					spotlightInitialCreateButtonDescription,
					createIssueModalCloseBtn,
					spotlightSelectIssueHeading,
					spotlightSelectIssueDescription,
					spotlightSummaryHeading,
					spotlightSummaryDescription,
					spotlightAddDescriptionHeading,
					spotlightAddDescriptionDescription,
					spotlightMoveIssueHeading,
					spotlightSelectPriorityHeading,
					spotlightMoveIssueDescription,
					spotlightSelectPriorityDescription,
					spotlightSelectEpicLinkHeading,
					spotlightSelectEpicLinkDescription,
					todoStaticLabel,
					inProgStaticLabel1,
					inProgStaticLabel2,
					doneStaticLabel1,
					doneStaticLabel2,
					successModalHeading,
					successModalDescription,
					successModalCtaButton}) => {
  return (
    <StyleReset>
      <AnalyticsListener onEvent={sendAnalytics}>
        <IntlProvider locale={document.documentElement.lang}>
          {versionSelect({
            version: 0,
            fields: {
              toDo,
					inProgress,
					done,
					create,
					restartDemo,
					avatarGroupAriaLabel,
					createIssueModalHeader,
					createIssueModalInput1Label,
					createIssueModalInput2Label,
					createIssueModalInput3Label,
					createIssueModalInput3Placeholder,
					createIssueModalInput4Label,
					createIssueModalInput4Placeholder,
					createIssueModalInput5Label,
					createIssueModalInput6Label,
					createIssueModalInput7Label,
					createIssueModalInput8Label,
					createIssueModalProjectOption1,
					createIssueModalProjectAssetLabel1,
					createIssueModalIssueTypeOption1,
					createIssueModalIssueTypeAssetLabel1,
					createIssueModalIssueTypeOption2,
					createIssueModalIssueTypeAssetLabel2,
					createIssueModalIssueTypeOption3,
					createIssueModalIssueTypeAssetLabel3,
					createIssueModalAssigneeOption1,
					createIssueModalAssigneeAssetLabel1,
					createIssueModalAssigneeOption2,
					createIssueModalAssigneeAssetLabel2,
					createIssueModalAssigneeOption3,
					createIssueModalAssigneeAssetLabel3,
					createIssueModalPriorityOption1,
					createIssueModalPriorityAssetLabel1,
					createIssueModalPriorityOption2,
					createIssueModalPriorityAssetLabel2,
					createIssueModalPriorityOption3,
					createIssueModalPriorityAssetLabel3,
					createIssueModalPriorityOption4,
					createIssueModalPriorityAssetLabel4,
					createIssueModalEpicLinkOption1,
					createIssueModalEpicLinkOption1Description,
					createIssueModalEpicLinkAssetLabel1,
					createIssueModalEpicLinkOption2,
					createIssueModalEpicLinkOption2Description,
					createIssueModalEpicLinkAssetLabel2,
					createIssueModalEpicLinkOption3,
					createIssueModalEpicLinkOption3Description,
					createIssueModalEpicLinkAssetLabel3,
					createIssueModalSubmitBtn,
					spotlightInitialCreateButtonHeading,
					spotlightInitialCreateButtonDescription,
					createIssueModalCloseBtn,
					spotlightSelectIssueHeading,
					spotlightSelectIssueDescription,
					spotlightSummaryHeading,
					spotlightSummaryDescription,
					spotlightAddDescriptionHeading,
					spotlightAddDescriptionDescription,
					spotlightMoveIssueHeading,
					spotlightSelectPriorityHeading,
					spotlightMoveIssueDescription,
					spotlightSelectPriorityDescription,
					spotlightSelectEpicLinkHeading,
					spotlightSelectEpicLinkDescription,
					todoStaticLabel,
					inProgStaticLabel1,
					inProgStaticLabel2,
					doneStaticLabel1,
					doneStaticLabel2,
					successModalHeading,
					successModalDescription,
					successModalCtaButton
            }
          })}
        </IntlProvider>
      </AnalyticsListener>
    </StyleReset>
  );
};

export default JswInteractiveBoardContainer;